import ManagePrintshops from './ManagePrintshops'

export default ManagePrintshops
